import React, { useEffect, useState } from 'react'

import { useAppDispatch, useAppSelector } from '../../../hooks';
import { inviteFundraisingAmbassador } from '../../../managers/redux/slices/fundraising';

// mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import { E164Number, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import MuiPhoneNumber from 'material-ui-phone-number';

import isEmail from 'validator/lib/isEmail'
import { COLORS } from '../../../theme/muiTheme';
import { StaffProfile, FundraisingProfile } from '../../../API';

interface InviteAmbassadorProps {
    visible: boolean
    onClose: (createdFundraisingProfile: FundraisingProfile | null) => void
}

export default function InviteAmbassador(props: InviteAmbassadorProps) {

    const dispatch = useAppDispatch()
    const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)

    useEffect(() => {
        setVisible(props.visible)
    }, [props.visible])

    function handleClose(createdFundraisingProfile: FundraisingProfile | null) {
        setVisible(false)
        setEmail(null)
        setFirstName(null)
        setLastName(null)
        props.onClose(createdFundraisingProfile)
    }

    const [visible, setVisible] = useState(false)
    const [email, setEmail] = useState<string | null>(null)
    const [phoneNumber, setPhoneNumber] = useState<E164Number | undefined>(undefined)
    const [firstName, setFirstName] = useState<string | null>(null)
    const [lastName, setLastName] = useState<string | null>(null)

    async function _handleClick() {
        const createFundraisingProfileInvitation = await dispatch(inviteFundraisingAmbassador({
            email: email,
            phoneNumber: phoneNumber ? phoneNumber.toString() : null,
            firstName: firstName,
            lastName: lastName
        }))
        if (createFundraisingProfileInvitation.payload && createFundraisingProfileInvitation.payload.fundraisingProfile) {
            handleClose(createFundraisingProfileInvitation.payload.fundraisingProfile)
        } else {
            handleClose(null)
        }

    }

    return (
        <div>
            <Dialog
                open={visible}
                onClose={() => handleClose(null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="lg"
                fullWidth
            >
                <div className="p-0">
                    <DialogContent>
                        <Typography variant="h3">Add a new {selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverrideSingular ? selectedStaffProfile.organization.ambassadorTermOverrideSingular : 'Ambassador'}</Typography>
                        <Typography variant="body1">Invite a new {selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverrideSingular ? selectedStaffProfile.organization.ambassadorTermOverrideSingular : 'Ambassador'} to your organization</Typography>

                        <div className="row flex-row justify-content-center align-items-center">
                            <div className="col-12 col-lg-6">
                                <TextField
                                    id="addFirstName"
                                    variant="outlined"
                                    label="First Name"
                                    placeholder="First Name"
                                    className="my-2"
                                    inputProps={{ style: { fontSize: 16 } }}
                                    fullWidth
                                    value={firstName}
                                    onChange={(e) => {
                                        setFirstName(e.target.value)
                                    }}
                                />
                            </div>
                            <div className="col-12 col-lg-6">
                                <TextField
                                    id="addLastName"
                                    variant="outlined"
                                    label="Last Name"
                                    placeholder="Last Name"
                                    className="my-2"
                                    inputProps={{ style: { fontSize: 16 } }}
                                    fullWidth
                                    value={lastName}
                                    onChange={(e) => {
                                        setLastName(e.target.value)
                                    }}
                                />
                            </div>
                            <div className="col-12 col-lg-6">
                                <TextField
                                    id="addTeamMemberEmail"
                                    variant="outlined"
                                    label="Email*"
                                    placeholder="Email Address"
                                    className="my-2"
                                    inputProps={{ style: { fontSize: 16 } }}
                                    fullWidth
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value)
                                    }}
                                />
                            </div>
                            <div className="col-12 col-lg-6">
                                <MuiPhoneNumber defaultCountry={'us'} name="phoneNumber" type="tel" countryCodeEditable={false} onChange={(e) => { console.log(e); if (typeof e == 'string' && isValidPhoneNumber(e)) setPhoneNumber(parsePhoneNumber(e).number); else setPhoneNumber(undefined) }} variant="outlined" placeholder="Phone Number" required fullWidth label="Phone Number" />
                            </div>
                        </div>
                    </DialogContent>
                </div>
                <DialogActions>
                    <Button
                        onClick={_handleClick}
                        variant="contained"
                        disabled={email != '' && email != null && !isEmail(email)}
                    >
                        Invite
                    </Button>
                    <Button onClick={() => handleClose(null)}>Close</Button>
                    {/* <Button
                        onClick={_handleClick}
                        variant="contained"
                        disabled={email != '' && email != null && !isEmail(email)}
                    >
                        Send Invitation
                    </Button> */}
                </DialogActions>
            </Dialog>
            <div id="map"></div>
        </div>
    )
}